export function isRunningOnServer(): boolean {
  return typeof window === 'undefined'
}
